module.exports = __webpack_public_path__ + "img/video_3.0169de1f.png";